export default __webpack_public_path__ + "static/media/jiezhifa_3.1b6d4cf2.png";